<template>
    <div>
        <vs-popup :active.sync="showPopup" title="Bezorglocatie toevoegen" v-if="location !== null">
            <div class="vx-row">
                <div>
                  <div class="vx-col w-full mb-2">

                    <v-select :options="locations" v-model="locations" multiple
                    >
                      <vs-select-item :text="item.name" v-for="item in locations"/>
                    </v-select>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-input
                            class="w-full"
                            label="Bezorgkosten"
                            :value="location.fee"
                            v-model="location.fee"
                    />
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-input
                            class="w-full"
                            label="Minimum bestelbedrag"
                            :value="location.minimum"
                            v-model="location.minimum"
                    />
                </div>
            </div>
            <div class="vx-row" style="float: right">
                <div class="vx-col">
                    <vs-button class="w-full vs-con-loading__container"
                               id="send-deliverer-notification"
                               ref="loadableButton"
                               @click="saveDeliveryLocation"
                    >Opslaan
                    </vs-button>
                </div>
            </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                search: '',
                showPopup: false,
                location: null,
                locations: []
            };
        },

        methods: {
            onOptionClick({ option, addTag }) {
                addTag(option)
                this.search = ''
            },
            saveDeliveryLocation() {
                let slug = this.$route.params.slug;
                let data = new FormData();
                console.log(this.createLocation);
                data.append('minimumOrderAmount', this.createLocation.minimum);
                data.append('companySlug', slug);
                data.append('deliveryFee', this.createLocation.fee);
                data.append('companyDeliveryLocationId', this.createLocation.location.id);
                this.$http
                    .post('/v1/delivery-fee/create', data, {
                        headers: {
                            Authorization: "Bearer " + this.$auth.token
                        },
                    })
                    .then(() => {
                        this.showPopup = false;
                        this.$vs.notify({
                            title: "Gelukt!",
                            text: "Locatie is toegevoegd aan restaurant",
                            color: "green",
                            position: "top-center",
                        });
                        this.$events.fire('refresh-delivery-locations');
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
            getGlobalDeliveryLocations() {
                this.$http.get('v1/delivery-fees?slug=' + this.$route.params.slug, {
                    headers: {
                        Authorization: "Bearer " + this.$auth.token
                    },
                }).then(response => {
                    this.locations = response.data.fees;
                }).catch(error => {
                    this.$util.logError(error, this.$vs);
                });
            },
        },
        mounted() {
            this.$events.listen('add-company-delivery-location', (locations) => {
                this.showPopup = true;
                this.locations = locations;
            });
        }
    };
</script>